import { connect } from 'react-redux';
import RecommonList from 'components/app-detail/recommon-list';

const mapStateToProps = (state, ownProps) => {
  const { recommonList } = state.appDetail;
  return { recommonList, ...ownProps };
};

export default connect(
  mapStateToProps,
  null
)(RecommonList);
